/**
 * WorkshopsCardBody — the "Workshops here" card contents: the loading and error
 * states, the table itself, and the "Load more" pager.
 *
 * Its own file so the tab declares one component (`react/no-multi-comp`), and
 * so the tab is left holding only the tab's own concerns.
 */
import type { WorkshopDirection } from '../../../../api/workshops';

import type { useVenueWorkshopsList } from './useVenueWorkshops';
import { WorkshopsTable } from './WorkshopsTable';

export function WorkshopsCardBody({
  query,
  direction,
}: {
  query: ReturnType<typeof useVenueWorkshopsList>;
  direction: WorkshopDirection;
}) {
  if (query.isLoading) {
    return <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>Loading workshops…</div>;
  }
  if (query.error) {
    return <div style={{ fontSize: 12, color: 'var(--nb-warn)' }}>Could not load workshops.</div>;
  }
  return (
    <>
      <WorkshopsTable workshops={query.data?.pages.flat() ?? []} direction={direction} />
      {query.hasNextPage && (
        <div style={{ marginTop: 10, textAlign: 'center' }}>
          <button
            type="button"
            className="nb-btn nb-btn-ghost"
            onClick={() => query.fetchNextPage()}
            disabled={query.isFetchingNextPage}
          >
            {query.isFetchingNextPage ? 'Loading…' : 'Load more'}
          </button>
        </div>
      )}
    </>
  );
}
